/* SponsoredSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { SponsoredAppEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { FluidContainer } from '@atlassian/mpac-primitives';
import { useEffect } from 'react';
import { SectionWrapper } from '../../HomepageCommon.styles';
import { SponsoredAppSection } from './SponsoredAppSection';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _9 = "@media (min-width:64rem) and (max-width:89.99rem){._1acz1gtx{padding:var(--_1bm102r)}}";
const _8 = "@media (min-width:48rem) and (max-width:63.99rem){._13zn1gtx{padding:var(--_1bm102r)}}";
const _7 = "@media not all and (min-width:48rem){._15txwcbu{padding:var(--_4thsry)}}";
const _6 = "._1wpz1fhb{align-self:stretch}";
const _5 = "._2lx21bp4{flex-direction:column}";
const _4 = "._1e0c1txw{display:flex}";
const _3 = "._kqswh2mm{position:relative}";
const _2 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _ = "._1yt4ojjz{padding:var(--_8gy4v2)}";
const SectionWrapperStyle = null;
export const SponsoredSection = _ref => {
  let {
    data,
    isLoading,
    isError,
    testId
  } = _ref;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    enableMpacWebCoherence
  } = useStatsig();
  useEffect(() => {
    if (data) {
      fireAnalyticsEvent({
        eventType: SponsoredAppEvent,
        eventContainer: testId,
        actionSubjectId: testId
      });
    }
  }, [data, testId]);
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5, _6, _7, _8, _9]
      }), /*#__PURE__*/_jsx("div", {
        "data-testid": testId,
        className: ax(["_1yt4ojjz _zulpxy5q _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1fhb _15txwcbu _13zn1gtx _1acz1gtx"]),
        style: {
          "--_8gy4v2": ix("var(--ds-space-800, 64px)".concat(" 0")),
          "--_1bm102r": ix("var(--ds-space-500, 40px)".concat(" 0")),
          "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
        },
        children: /*#__PURE__*/_jsx(SponsoredAppSection, {
          isLoading: isLoading,
          isError: isError,
          data: data
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(FluidContainer, {
    children: /*#__PURE__*/_jsx(SectionWrapper, {
      "data-testid": testId,
      children: /*#__PURE__*/_jsx(SponsoredAppSection, {
        isLoading: isLoading,
        isError: isError,
        data: data
      })
    })
  });
};